<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialogRestorePayment"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogRestorePayment"
      >
        <v-card class="no__padding">
          <v-card-title class="pl-0">
            <h2>Opravdu chcete obnovit tuto platbu?</h2>
          </v-card-title>
          <v-card color="grey lighten-4" class="pa-2 elevation-0">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Datum a čas:</p> <strong>{{item.datum | formatDate}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Částka:</p> <strong>{{item.castka | formatMoney}} {{item.mena.zkratka}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Variabilní symbol:</p> <strong>{{item.variabilni_symbol}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Protiúčet:</p> <strong>{{item.protiucet}}/{{item.protiucet_kod}}</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md6>
                  <p class="grey--text caption mb-1">Zpráva pro příjemce:</p> <strong>{{item.poznamka}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <!--<p class="grey--text caption mb-1">Klient:</p> <strong>{{item.osoba.nazev_osoby}}</strong>-->
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card-actions class="mt-3 pr-0">
            <v-spacer></v-spacer>
            <v-btn color="green elevation-0" dark @click="restorePayment" :loading="restoringPayment">Ano, obnovit platbu</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogRestorePayment=false" v-if="!restoringPayment">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12>
                <h3>Platby k vrácení</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-btn color="primary" class="ma-0" depressed>Generovat ABO formát pro banku</v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1 mt-3">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.datum  | formatDate }}</td>
                  <td>{{ props.item.castka | formatMoney }} {{props.item.mena.zkratka}}</td>
                  <td>{{ props.item.variabilni_symbol }}</td>
                  <td v-if="props.item.protiucet != null">{{ props.item.protiucet }}/{{props.item.protiucet_kod}}</td>
                  <td v-else>--</td>
                  <td v-if="props.item.poznamka != null">{{ props.item.poznamka }}</td>
                  <td v-else>--</td>
                  <td class="text-center">
                    <div v-if="props.item.sparovano == 0">
                      <v-layout row>
                        <v-flex d-flex>
                          <v-btn color="primary" class="elevation-0" @click="restorePaymentClick(props.item)">
                          <v-icon small class="mr-2">replay</v-icon> Obnovit platbu</v-btn>
                        </v-flex>
                      </v-layout>
                      <!--<v-btn v-else color="primary" class="elevation-0" @click="item = props.item;dialogDetail=true">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Zrušit spárování</v-btn>-->
                    </div>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      dialogDetail: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Datum a čas', value: 'datum' },
        { text: 'Částka', value: 'castka' },
        { text: 'Variabilní symbol', value: 'variabilni_symbol' },
        { text: 'Protiúčet', value: 'protiucet' },
        { text: 'Zpráva pro příjemce', value: 'poznamka' },
        { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      items: [],
      item: {},
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      dialogRestorePayment: false,
      restoringPayment: false
    }
  },
  watch: {
    pagination: {
      deep: true,
      handler (v) {
        this.load();
      }
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function(f) {
      this.counter++;
      this.loadingTable = true;
      window.API.post("platby/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        k_vraceni: true
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    restorePaymentClick(v) {
      this.item = v;
      this.dialogRestorePayment = true;
    },
    restorePayment () {
      this.restoringPayment = true;
      window.API.get("platby/"+this.item.id+"/obnovit-platbu").then(function(body) {
        if (body.status) {
          this.items.splice(this.items.indexOf(this.item), 1);
          this.load(() => {
            this.restoringPayment = false;
            this.dialogRestorePayment = false;
          });
        }
        else
          this.restoringPayment = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.restoringPayment = false;
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Platby/PlatbyVraceni.vue